import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { useIsVisible } from '@folklore/hooks';
import { loadTwitter, loadInstagram, loadTikTok } from '@folklore/services';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useRef, useMemo, useEffect } from 'react';
import { Widget } from '@niche-js/core/components';

var styles = {"iframeContainer":"niche-js-block-embed-iframeContainer"};

var propTypes = {
  embed: PropTypes.shape({
    url: PropTypes.string,
    provider: PropTypes.string,
    iframeUrl: PropTypes.string,
    html: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number
  }),
  loading: PropTypes.string,
  className: PropTypes.string
};
var defaultProps = {
  embed: null,
  loading: 'lazy',
  className: null
};
function Embed(_ref) {
  var embed = _ref.embed,
    loading = _ref.loading,
    className = _ref.className;
  var refEmbed = useRef();
  var _ref2 = embed || {},
    provider = _ref2.provider,
    _ref2$iframeUrl = _ref2.iframeUrl,
    iframeUrl = _ref2$iframeUrl === void 0 ? null : _ref2$iframeUrl,
    _ref2$html = _ref2.html,
    html = _ref2$html === void 0 ? null : _ref2$html,
    width = _ref2.width,
    height = _ref2.height;
  var finalFrameUrl = useMemo(function () {
    return iframeUrl || null;
  }, [iframeUrl]);
  var iframeContainerRef = useRef(null);
  var _useIsVisible = useIsVisible({
      rootMargin: '200px',
      persist: true,
      disabled: loading !== 'lazy'
    }),
    visibleRef = _useIsVisible.ref,
    isVisible = _useIsVisible.visible;
  var shouldLoad = loading !== 'lazy' || isVisible;
  useEffect(function () {
    var _iframeContainerRef$c = iframeContainerRef.current,
      element = _iframeContainerRef$c === void 0 ? null : _iframeContainerRef$c;
    if (provider === 'twitter' && shouldLoad) {
      loadTwitter().then(function (twttr) {
        if (element !== null) {
          twttr.widgets.load(element);
        }
      });
    } else if (provider === 'instagram' && shouldLoad) {
      loadInstagram().then(function () {
        if (typeof window !== 'undefined' && typeof window.instgrm !== 'undefined') {
          window.instgrm.Embeds.process();
        }
      });
    } else if (provider === 'tiktok' && shouldLoad) {
      loadTikTok();
    }
  }, [provider, shouldLoad]);
  return /*#__PURE__*/React.createElement(Widget, {
    ref: visibleRef,
    className: classNames([styles.container, _defineProperty({}, className, className !== null)])
  }, finalFrameUrl !== null ? /*#__PURE__*/React.createElement("div", {
    className: styles.iframeContainer,
    ref: iframeContainerRef
  }, shouldLoad ? /*#__PURE__*/React.createElement("iframe", {
    src: finalFrameUrl,
    ref: refEmbed,
    className: classNames([styles.iframe, "iframe-".concat(provider)]),
    frameBorder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: true,
    title: "Embed",
    width: width || '100%',
    height: height || '100%'
  }) : null) : null, finalFrameUrl === null && html !== null ? /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.iframeContainer]),
    dangerouslySetInnerHTML: {
      __html: html
    },
    ref: iframeContainerRef
  }) : null);
}
Embed.propTypes = propTypes;
Embed.defaultProps = defaultProps;

export { Embed as default };
